import { buildOauthStateString } from "@WombatTechnology/nitte-time-lib"
import { useExtractedDatesStore } from "@/store/extractedDatesStore"

const INPUT_KEY = 'nitte-text-receive-input-text'
const DATES_KEY = 'nitte-text-receive-extracted-dates'

const saveStoreState = () => {
  const store = useExtractedDatesStore()
  if (store.inputText) {
    sessionStorage.setItem(INPUT_KEY, store.inputText)
  }
  if (store.extractedDates.length > 0) {
    sessionStorage.setItem(DATES_KEY, JSON.stringify(store.extractedDates))
  }
}

export const restoreStoreState = () => {
  const store = useExtractedDatesStore()
  const text = sessionStorage.getItem(INPUT_KEY)
  const dates = sessionStorage.getItem(DATES_KEY)
  if (text) {
    store.inputText = text
    sessionStorage.removeItem(INPUT_KEY)
  }
  if (dates) {
    store.extractedDates = JSON.parse(dates, (key, value) => {
      if ((key === 'start' || key === 'end') && typeof value === 'string') {
        return new Date(value)
      }
      return value
    })
    store.skipNextExtraction = true
    sessionStorage.removeItem(DATES_KEY)
  }
}

export const auth = () => {
  saveStoreState()
  const stateString = buildOauthStateString(true, "text-receive", null)
  window.location.href = `${
    import.meta.env.VITE_APP_CLOUD_FUNCTION_URL
  }/internal_api/auth/google?state=${stateString}`
}

export const authMs = () => {
  saveStoreState()
  const stateString = buildOauthStateString(true, "text-receive", null)
  window.location.href = `${
    import.meta.env.VITE_APP_CLOUD_FUNCTION_URL
  }/internal_api/auth/microsoft?state=${stateString}`
}
